/**
 * Import Dependency
 */
import { handleActions } from 'redux-actions'

/**
 * Declare Variable
 */
const defaultMerchantState = null

/**
 * Export
 */
export const merchant = handleActions({
  GET_MERCHANT: (state, action) => {
    return action.payload
  },
}, defaultMerchantState)

export default {
  merchant,
}



// WEBPACK FOOTER //
// ./src/reducers/components/merchant.js